import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import { forwardRef, useEffect } from 'react';
import { useLocalRef } from '../../hooks/useLocalRef.js';
import { block } from '../../utils/block.js';
import './Dropdown.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgArrowUp } from '../../static/icons/action/arrow_up.svg.js';

const _excluded = ["children", "isOpen", "onToggle", "closeOnClickOutside", "color", "disabled", "withArrow", "isAbsolute", "className", "buttonClassName", "list", "closeOnFocusOutside", "id"];
const b = block('dropdown');
const Dropdown = /*#__PURE__*/forwardRef(function Dropdown(_ref, ref) {
  let {
      children,
      isOpen,
      onToggle,
      closeOnClickOutside,
      color,
      disabled,
      withArrow,
      isAbsolute,
      className = '',
      buttonClassName = '',
      list,
      closeOnFocusOutside,
      id
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    localRef,
    localRefFunction
  } = useLocalRef(ref);
  const onDropdownClick = e => {
    if (disabled) {
      return;
    }
    if (e.target === e.currentTarget) {
      onToggle();
    }
  };
  useEffect(() => {
    const listener = () => {
      // necessary because the event is triggered between losing the previous focus and receiving the new focus
      setTimeout(() => {
        if (isOpen && localRef.current && !localRef.current.contains(document.activeElement)) {
          onToggle();
        }
      }, 0);
    };
    closeOnFocusOutside && window.addEventListener('focusout', listener);
    return () => {
      closeOnFocusOutside && window.removeEventListener('focusout', listener);
    };
  }, [closeOnFocusOutside, isOpen]);
  useEffect(() => {
    const listener = e => {
      if (!e.target || !isOpen || !localRef.current) {
        return;
      }
      const target = e.target;
      if (!localRef.current.contains(target)) {
        onToggle();
      }
    };
    closeOnClickOutside && window.addEventListener('click', listener);
    return () => {
      closeOnClickOutside && window.removeEventListener('click', listener);
    };
  }, [closeOnClickOutside, isOpen]);
  return /*#__PURE__*/jsxs("div", {
    className: b({
      absolute: isAbsolute,
      open: isOpen,
      color
    }).mix(className),
    ref: localRefFunction,
    id: id,
    children: [/*#__PURE__*/jsxs("button", _objectSpread2(_objectSpread2({
      className: b('button', {
        color,
        disabled
      }).mix(buttonClassName),
      onClick: onDropdownClick,
      "aria-disabled": disabled,
      id: "".concat(id, "-button")
    }, rest), {}, {
      children: [children, /*#__PURE__*/jsx(SvgArrowUp, {
        className: b('arrow', {
          hidden: !withArrow
        }),
        "aria-hidden": true
      })]
    })), list]
  });
});
Dropdown.displayName = 'Dropdown';

export { Dropdown };
